export default class AwsAccount {
    constructor () {

        this.id = null
        this.aws_account_id = null
        this.name = ""
        this.charge = true
        this.terraform_workspace_name = ""
    }
}